import { render, staticRenderFns } from "./PrePrintPage.vue?vue&type=template&id=3d5456c4&scoped=true"
import script from "./PrePrintPage.vue?vue&type=script&lang=js"
export * from "./PrePrintPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5456c4",
  null
  
)

export default component.exports